import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Plus, X } from "lucide-react";
import { ID_INPUT } from "@/components/identity/Identity";

export const EMAIL_RX = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
export const PHONE_RX = /^\+?[\d\s().-]{7,20}$/;
export const phoneOk = (p) => PHONE_RX.test(p.trim()) && p.replace(/\D/g, "").length >= 7 && p.replace(/\D/g, "").length <= 15;
export const CONTACT_ROLES = [["PROCUREMENT", "Procurement"], ["FINANCE", "Finance / accounts"], ["IT", "IT"], ["SALES", "Sales"], ["OTHER", "Other"]];
const sel = "w-full h-9 border border-slate-200 rounded-md px-2 text-[13px] bg-white";
const rm = "mt-5 h-9 w-9 shrink-0 rounded-md border border-slate-200 text-slate-500 hover:text-rose-600";

export function AddRowButton({ label, onClick, testid }) {
  return <button type="button" onClick={onClick} className="inline-flex items-center gap-1 rounded-md border border-dashed border-slate-300 px-2 py-1 text-[11.5px] font-semibold text-slate-600 hover:border-slate-500 hover:text-slate-900" data-testid={testid}><Plus className="h-3.5 w-3.5" />{label}</button>;
}

/** Optional extra emails / numbers: unsaved rows can be removed; casing and + prefixes are kept. */
export function ExtraValues({ kind, values, setValues }) {
  const isEmail = kind === "email";
  const bad = (v) => v.trim() && !(isEmail ? EMAIL_RX.test(v.trim()) : phoneOk(v));
  return values.map((v, i) => (
    <div key={i} className="flex items-start gap-2" data-testid={`add-customer-extra-${kind}-row-${i}`}>
      <div className="flex-1"><Label>{isEmail ? `Additional email ${i + 1}` : `Additional number ${i + 1}`}</Label>
        <Input value={v} onChange={(e) => setValues(values.map((x, j) => (j === i ? e.target.value : x)))} placeholder={isEmail ? "name@customer.com" : "+91 98400 00000"} inputMode={isEmail ? "email" : "tel"} data-testid={`add-customer-extra-${kind}-${i}`} />
        {bad(v) && <div className="text-[10.5px] text-rose-600" data-testid={`add-customer-extra-${kind}-${i}-error`}>{isEmail ? "Not a valid email" : "Not a valid number"}</div>}</div>
      <button type="button" onClick={() => setValues(values.filter((_, j) => j !== i))} className={rm} aria-label="Remove" data-testid={`add-customer-extra-${kind}-remove-${i}`}><X className="mx-auto h-4 w-4" /></button>
    </div>
  ));
}

export function ExtraContacts({ rows, setRows }) {
  const set = (i, k, v) => setRows(rows.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  return rows.map((r, i) => (
    <div key={i} className="rounded-lg border border-slate-200 p-3" data-testid={`add-customer-extra-contact-${i}`}>
      <div className="flex items-start gap-2">
        <div className="grid flex-1 grid-cols-1 gap-2 sm:grid-cols-2">
          <div><Label>Role</Label><select value={r.role} onChange={(e) => set(i, "role", e.target.value)} className={sel} data-testid={`add-customer-extra-contact-${i}-role`}>{CONTACT_ROLES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select></div>
          <div><Label>Name *</Label><Input value={r.name} onChange={(e) => set(i, "name", e.target.value)} className={ID_INPUT} data-testid={`add-customer-extra-contact-${i}-name`} /></div>
          <div><Label>Designation</Label><Input value={r.designation} onChange={(e) => set(i, "designation", e.target.value)} data-testid={`add-customer-extra-contact-${i}-designation`} /></div>
          <div><Label>Email</Label><Input value={r.email} onChange={(e) => set(i, "email", e.target.value)} data-testid={`add-customer-extra-contact-${i}-email`} /></div>
          <div className="sm:col-span-2"><Label>Mobile</Label><Input value={r.mobile} onChange={(e) => set(i, "mobile", e.target.value)} inputMode="tel" data-testid={`add-customer-extra-contact-${i}-mobile`} /></div>
        </div>
        <button type="button" onClick={() => setRows(rows.filter((_, j) => j !== i))} className={rm} aria-label="Remove contact" data-testid={`add-customer-extra-contact-${i}-remove`}><X className="mx-auto h-4 w-4" /></button>
      </div>
    </div>
  ));
}

export const extraContactProblem = (rows) => {
  for (const r of rows) {
    const any = r.name.trim() || r.email.trim() || r.mobile.trim();
    if (any && !r.name.trim()) return "Each additional contact needs a name";
    if (r.email.trim() && !EMAIL_RX.test(r.email.trim())) return `${r.email} is not a valid email`;
    if (r.mobile.trim() && !phoneOk(r.mobile)) return `${r.mobile} is not a valid number`;
  }
  return null;
};
